import {BehaviorSubject} from 'rxjs';
import {Estimate} from '../models/estimate';

export class EstimatesRepository {
    private subject: BehaviorSubject<Estimate[]>;

    constructor(seed: Estimate[]) {
        this.subject = new BehaviorSubject(seed);
    }

    public all(): Estimate[] {
        return this.subject.value;
    }
}
